export default __webpack_public_path__ + "static/media/microphone.0d459ab9.svg";